import axios from 'axios'
import {
  Message,
  MessageBox
} from 'element-ui'
import {
  removeAuth
} from '@/utils/auth'
import qs from 'qs'
import Lockr from 'lockr'

var showLoginMessageBox = false
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'
// 建立axios實例
// let hrefs = []
// if (window.location.href.indexOf('index.html') != -1) {
//   hrefs = window.location.href.split('index.html')
// } else {
//   hrefs = window.location.href.split('#')
// }

// const baseURL = window.location.protocol + "//crm.elitestargp.com/app.php/"
// baseURL + 'index.php/' 預設請求地址
// process.env.BASE_API 自定義請求地址
// window.BASE_URL = process.env.NODE_ENV === 'production' ? baseURL + 'app.php/' : process.env.BASE_API
// 在开发环境中使用代理路径 /api，在生产环境中使用完整URL
window.BASE_URL = process.env.NODE_ENV === 'development' ? '/api/' : '//crm.tuoyuanpre.com//app.php/'

const service = axios.create({
  baseURL: window.BASE_URL, // api 的 base_url
  timeout: 15000 // 請求超時時間
})

// request攔截器
service.interceptors.request.use(
  config => {
    // 确保每次请求都携带authKey和sessionId
    if (Lockr.get('authKey')) {
      config.headers['authKey'] = Lockr.get('authKey')
    }
    if (Lockr.get('sessionId')) {
      config.headers['sessionId'] = Lockr.get('sessionId')
    }

    if (!config.headers['Content-Type'] || config.headers['Content-Type'].indexOf('multipart/form-data') == -1) {
      config.data = qs.stringify(config.data)
    }
    return config
  },
  error => {
    // Do something with request error
    return Promise.reject(error)
  }
)

// response 攔截器
service.interceptors.response.use(
  response => {
    /**
     * code為非200是拋錯
     */
    const res = response.data
    if (response.status === 200 && response.config.responseType === 'blob') { // 檔案型別特殊處理
      return response
    } else if (res.code !== 200) {
      // 101	登錄已失效 102	沒有許可權 103	賬號已被刪除或禁用
      if (res.code === 101) {
        if (!showLoginMessageBox) {
          showLoginMessageBox = true
          MessageBox.confirm(
            '你已被登出，請重新登錄',
            '確定登出', {
              showCancelButton: false,
              showClose: false,
              confirmButtonText: '重新登錄',
              type: 'warning',
              callback: action => {
                showLoginMessageBox = false
                if (action === 'confirm') {
                  removeAuth().then(() => {
                    location.reload() // 爲了重新實例化vue-router對像 避免bug
                  }).catch(() => {
                    location.reload()
                  })
                }
              }
            }
          )
        }
      } else if (res.code === 402) {
        if (res.error && Object.prototype.toString.call(res.error) === '[object Array]') {
          res.error = res.error.reduce(function(prev, cur, index, array) {
            return prev + '\r\n' + cur
          })
        }
        Message({
          showClose: true,
          duration: 0,
          customClass: 'el-close-message',
          message: res.error,
          type: 'error'
        })
      } else {
        if (res.error) {
          Message({
            message: res.error,
            type: 'error'
          })
        }
      }
      return Promise.reject(res)
    } else {
      return res
    }
  },
  error => {
    Message({
      message: '網路請求失敗，請稍候再試',
      type: 'error'
    })
    return Promise.reject(error)
  }
)

export default service
